<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12">
        <g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="round">
            <g>
                <path d="M5 0L2.5 2" transform="translate(0 1) translate(4) matrix(-1 0 0 1 7.5 0)"/>
                <path d="M2.5 0L0 2M2.5 7L2.5 0" transform="translate(0 1) translate(4)"/>
            </g>
            <path d="M.5 10L.5 6M12 10L12 6M.6 10L12 10" transform="translate(0 1)"/>
        </g>
    </svg>
</template>
<script>
export default { name: 'upload-icon' }
</script>
